export default __webpack_public_path__ + "swim-branch-transparent.svg";